import { logger } from '@/utils/logger';
import { env } from '@zopauk/nextjs-env';
import axios, { type AxiosInstance } from 'axios';
import { correlationInterceptor, loggerInterceptor, csrfInterceptor } from '@zopauk/libs-axios';

let instance: AxiosInstance;

const isDev = env('NEXT_PUBLIC_APP_ENV') === 'development';

/**
 * Set the Application api axios instance
 *
 * @returns AxiosInstance
 */
const initAppInstance = () => {
  instance = axios.create({
    withCredentials: true,
    baseURL: '/api',
  });

  csrfInterceptor({ instance });
  correlationInterceptor({ instance });
  loggerInterceptor({
    identifier: 'CLIENT API',
    verbose: isDev,
    instance,
    logger,
  });

  return instance;
};

export const getAppInstance = () => instance || initAppInstance();
